/**
 * /vault/workshop — recorrido guiado del Vault que se opera solo (pedido de
 * Sol 25/09: "algo así como novum-erp.com/demo/workshop pero de Vault").
 *
 * Abierto a todo autenticado: es la forma de conocer el Vault ANTES de tener
 * accesos, 2SV o passphrase. Corre sobre datos de demo en memoria
 * (lib/vault-demo); nada de lo que hace toca el Vault real.
 */
import { useCallback, useState } from 'react';
import { useAuth } from '@/contexts/SharedAuthContext';
import { WorkshopLanding } from '@/components/vault/workshop/WorkshopLanding';
import { WorkshopPlayer } from '@/components/vault/workshop/WorkshopPlayer';
import { VAULT_WORKSHOP } from '@/components/vault/workshop/script';
import { useWorkshopSettings } from '@/components/vault/workshop/settings';
import manifestJson from '@/components/vault/workshop/manifest.json';
import type { WorkshopManifest } from '@/components/vault/workshop/types';

const MANIFEST = manifestJson as WorkshopManifest;

export function WorkshopPage() {
  const { user } = useAuth();
  const [settings, updateSettings] = useWorkshopSettings();
  // null = landing; número = capítulo por el que arranca la reproducción
  const [playingFrom, setPlayingFrom] = useState<number | null>(null);
  // cada reproducción remonta el player (Vault de demo nuevo): también "Volver a ver"
  const [run, setRun] = useState(0);
  const play = useCallback((from: number) => {
    setRun((r) => r + 1);
    setPlayingFrom(from);
  }, []);
  const exit = useCallback(() => setPlayingFrom(null), []);
  const replay = useCallback(() => play(0), [play]);

  if (playingFrom === null) {
    return <WorkshopLanding workshop={VAULT_WORKSHOP} manifest={MANIFEST} settings={settings} onSettings={updateSettings} onPlay={play} />;
  }
  return (
    <WorkshopPlayer
      key={`${run}-${playingFrom}`}
      workshop={VAULT_WORKSHOP}
      manifest={MANIFEST}
      settings={settings}
      viewerEmail={user?.email ?? 'vos@winclap.com'}
      startAt={playingFrom}
      onExit={exit}
      onReplay={replay}
    />
  );
}
